<template>
  <div class="captcha">
    <div class="form__item__prefix">
      <img class="form__item__prefix__img" src="../assets/img/icon-unlock.png" />
    </div>
    <input
      class="form__item__input captcha__input"
      type="text"
      :value="value"
      :placeholder="placeholder || '输入验证码'"
      @input="inputHandler"
      @blur="blurHandler" />
    <button type="button" :disabled="loading" class="button captcha__btn" @click="getCaptcha">{{loading ? loadingTime + 's后获取' : '获取验证码'}}</button>
  </div>
</template>
<script>
import formItemInput from '@/mixins/formItemInput'
import '@/assets/less/captcha.less'

const initTime = 60

export default {
  props: {
    checkPhoneFn: Function
  },
  mixins: [ formItemInput ],
  data() {
    return {
      loading: false,
      loadingTime: initTime
    }
  },
  methods: {
    async getCaptcha(res) {
      const phone = this.checkPhoneFn()
      if (!phone) {
        return
      }
      /* eslint-disable no-new */
      try {
        const tcCaptcha = new window.TencentCaptcha(
          '2089780657',
          async (captchaRes) => {
            if (!captchaRes.ticket) {
              return
            }
            this.loading = true
            this.loadingTime = initTime
            const { status, data } = await this.$post(this.$CGI.login.getCaptcha, {
              phone,
              ticket: captchaRes.ticket,
              randstr: captchaRes.randstr
            }, false)
            if (status === 200) {
              this.$emit('success', data)
              // 60s后再次获取
              const inter = setInterval(() => {
                this.loadingTime -= 1
              }, 1000)
              setTimeout(() => {
                clearInterval(inter)
                this.loading = false
              }, initTime * 1000)
            } else {
              this.$emit('error', data)
              this.loading = false
            }
          }
        )
        tcCaptcha.show()
      } catch (e) {
        this.$Message.error('防水墙组件错误，暂时无法获取验证码，请联系系统管理员')
        // this.$refs.message.error('防水墙组件错误，暂时无法获取验证码')
      }
    }
  }
}
</script>
